// Stock > Volumetria por camião — cliente da API interna (sessão).
import axios from 'axios';

const BASE_URL = '/api/stock/trucks';

const client = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
  withCredentials: true,
});

// Sessão expirada -> login (mesmo comportamento do resto da app)
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && window.location.pathname !== '/login') {
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

export type TruckRoute = 'Norte' | 'Sul' | 'Leiria';

export interface TruckStore {
  loja: string;
  unidades: number;
  m3: number;
  entregas: number;
}

export interface Truck {
  dia: string;
  rota: TruckRoute;
  dia_semana: number; // 1 = domingo (BigQuery)
  unidades: number;
  entregas: number;
  linhas: number;
  m3: number;
  m3_imputado: number;
  m3_capacidade: number | null;
  paletes_capacidade: number | null;
  paletes_equiv: number;
  ocupacao_pct: number | null;
  data_641: string;
  lojas: TruckStore[];
}

export interface TrucksSummary {
  start: string;
  end: string;
  trucks: Truck[];
  routes: TruckRoute[];
  min_date: string | null;
  max_date: string | null;
  calculated_at: string | null;
  pallet_m3: number | null;
}

export interface TruckProduct {
  sku: string;
  nome: string | null;
  cat1: string | null;
  cat2: string | null;
  vol_dm3: number;
  vol_sap: number | null;
  vol_fonte: 'sap' | 'anomalo' | 'em_falta';
  unidades: number;
  m3: number;
  lojas: string[];
}

export interface TruckDay {
  dia: string;
  rota: TruckRoute | null;
  products: TruckProduct[];
  truncated: boolean;
  by_cat1: Array<{ cat1: string; unidades: number; m3: number }>;
}

export const stockTrucksApi = {
  getSummary: async (start: string, end: string): Promise<TrucksSummary> =>
    (await client.get('/summary/', { params: { start, end } })).data,

  getDay: async (dia: string, rota?: TruckRoute): Promise<TruckDay> =>
    (await client.get(`/day/${dia}/`, { params: rota ? { rota } : {} })).data,
};
